import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { Institution } from '@shared/services/mrrp/types/getInstitutions.types';
import type { Purpose } from '@shared/services/mrrp/types/getPurpose.types';
import type { ReportType } from '@shared/services/mrrp/types/getReportType.types';

import { initialState } from './initialState';
import type { CollectionValues, ParticularsValues, Payment, ReportDetailsValues } from '../types/mrrp.types';

const mrrpSlice = createSlice({
  initialState,
  name: 'MRRP',
  reducers: {
    resetCollectionValue: (state) => {
      state.newRequestFormValues.collectionValues = initialState.newRequestFormValues.collectionValues;
    },
    resetNewRequestFormValues: (state) => {
      state.newRequestFormValues = initialState.newRequestFormValues;
    },
    resetPaymentInfo: (state) => {
      state.payment = initialState.payment;
    },
    resetViewRequestedInstitute: (state) => {
      state.viewRequestedInstitute = initialState.viewRequestedInstitute;
    },
    setCollectionValue: (state, action: PayloadAction<CollectionValues>) => {
      state.newRequestFormValues.collectionValues = action.payload;
    },
    // new request form values
    setInstitueValue: (state, action: PayloadAction<Institution>) => {
      state.newRequestFormValues.institute = action.payload;
    },
    setParticularsValue: (state, action: PayloadAction<ParticularsValues>) => {
      state.newRequestFormValues.particularsValues = action.payload;
    },
    // payment
    setPaymentInfo: (state, action: PayloadAction<Payment>) => {
      state.payment = action.payload;
    },
    setPurposeOptions: (state, action: PayloadAction<Purpose[]>) => {
      state.newRequestFormOptions.purposeOptions = action.payload;
    },
    setReportDetailsValue: (state, action: PayloadAction<ReportDetailsValues>) => {
      state.newRequestFormValues.reportDetailsValue = action.payload;
    },
    // new request form options
    setReportTypeOptions: (state, action: PayloadAction<ReportType[]>) => {
      state.newRequestFormOptions.reportTypeOptions = action.payload;
    },
    // view request
    setViewRequestedInstitute: (state, action: PayloadAction<Institution>) => {
      state.viewRequestedInstitute = action.payload;
    },
  },
});

export const { actions: mrrpAction } = mrrpSlice;

export default mrrpSlice.reducer;
